'use client';

import { RecaptchaProvider } from '@/components/shared/RecaptchaProvider';
import FooterNewsLetter from './FooterNewsLetter';


interface Props {
    domain: string;
    companyId: string;
}

const FooterNewsletterRedesignWrapper = ({ domain, companyId }: Props) => {
    return (
        <RecaptchaProvider domain={domain}>
            <FooterNewsLetter domain={domain} companyId={companyId} />
        </RecaptchaProvider>
    );
};

export default FooterNewsletterRedesignWrapper;
